import { SYSTEM_FALLBACK } from '@/lib/fallback-value';

type ReferenceValue = {
  normalText: string | null;
  normalRangeLow: number | null;
  normalRangeHigh: number | null;
};

const formatReferenceRange = (
  low: number | null,
  high: number | null,
): string => {
  if (low !== null && high !== null) return `${low}～${high}`;
  if (high !== null) return `<${high}`;
  if (low !== null) return `>${low}`;

  return SYSTEM_FALLBACK;
};

export const formatReferenceValue = ({
  normalText,
  normalRangeLow,
  normalRangeHigh,
}: ReferenceValue): string => {
  if (normalText) return normalText;

  return formatReferenceRange(normalRangeLow, normalRangeHigh);
};
